import { useState } from 'react';

import type { SortState } from '../../components/DataTable/types';

export default function useSortState<T>(initialState: SortState<T>[] | (() => SortState<T>[])) {
  const [sortState, setSortState] = useState<SortState<T>[]>(initialState);

  return [sortState, setSortState] as const;
}
